import React, { useState } from 'react'
import NavBar from '../../components/navBar/NavBar'
import './login.css'
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth, db } from '../../utitilties/firebase';
import {  useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';


const Login = () => {

    const navigate = useNavigate()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const loginHandler = async () => {
        await signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                if (user.email == 'admin@orebro.com') {
                    navigate('/', { state: { isSuperAdmin: true } })

                } else if (checkIfCenterEmail(user.email)) {
                    navigate('/', { state: { isSuperAdmin: false } })

                } else {
                    signOut(auth).then(() => {
                    }).catch((error) => {
                    });
                    navigate('/login')


                }
            })
            .catch((error) => {
               
                alert(error.message)
            });
    }

    const checkIfCenterEmail = async (email) => {
        const q = query(collection(db, "PhysioCenters"), where("email", "==", email));

        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            return false
        } else {
            return true
        }
      
    }

    return (
        <>
            <NavBar />
            <div className='login'>
                <div className='login_sub' >
                    <h1>Admin Login</h1>

                    <input
                        type="text"
                        className="text_input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                    />
                    <input
                        type="password"
                        className="text_input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        
                    />

                    <div className="btn"
                        onClick={loginHandler}
                    >
                        <p>Login</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login